import moment from 'moment';

export default date => date && moment(date, 'YYYY-MM-DD').format('l');



// WEBPACK FOOTER //
// ./src/utils/formatDate.js